// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"385de427","333":"0b0b1a1b","644":"6714b66a","757":"2784b8c5","777":"978fe4b0","779":"e750f2e1","827":"63d30d13","875":"b37fad64"}[chunkId] + ".chunk.js";
};